
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoi4Liq4Lix4LiN4Lil4Lix4LiB4Lip4LiT4LmM4Lii4Li34LiZ4Lii4Lix4LiZ4LiV4Lix4Lin4LiV4LiZIn0=!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoi4Liq4Lix4LiN4Lil4Lix4LiB4Lip4LiT4LmM4Lii4Li34LiZ4Lii4Lix4LiZ4LiV4Lix4Lin4LiV4LiZIn0=!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiSWtvbiB0ZXJ2ZXJpZmlrYXNpIn0=!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiSWtvbiB0ZXJ2ZXJpZmlrYXNpIn0=!"
        )
      ),
"zh": createLanguage(
        require.resolveWeak("./translations.json-zh-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"),
        () => import(
          /* webpackChunkName: "zh-translations" */
          "./translations.json-zh-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoi4Liq4Lix4LiN4Lil4Lix4LiB4Lip4LiT4LmM4Lii4Li34LiZ4Lii4Lix4LiZ4LiV4Lix4Lin4LiV4LiZIn0=!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoi4Liq4Lix4LiN4Lil4Lix4LiB4Lip4LiT4LmM4Lii4Li34LiZ4Lii4Lix4LiZ4LiV4Lix4Lin4LiV4LiZIn0=!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiSWtvbiB0ZXJ2ZXJpZmlrYXNpIn0=!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiSWtvbiB0ZXJ2ZXJpZmlrYXNpIn0=!"
        )
      ),
"zh-HK": createLanguage(
        require.resolveWeak("./translations.json-zh-HK-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"),
        () => import(
          /* webpackChunkName: "zh-HK-translations" */
          "./translations.json-zh-HK-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiVmVyaWZpZWQgSWNvbiJ9!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiW+G5vOG6veG6veG6vcWZw6zDrMOsxpLDrMOsw6zhur3hur3hur3GjCDDj8Onw7bDtsO24LiB4Li14LmJXSJ9!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJWZXJpZmllZCBJY29uIjoiW+G5vOG6veG6veG6vcWZw6zDrMOsxpLDrMOsw6zhur3hur3hur3GjCDDj8Onw7bDtsO24LiB4Li14LmJXSJ9!"
        )
      )
      });
  
      export { translations as default };
    